import * as yup from 'yup';
import { pt } from 'yup-locale-pt';

yup.setLocale(pt);

export default yup;
